import { lazy } from "react";
import { Navigate } from "react-router";
import { BinaryCheck } from "src/components/binary";
import Ternary from "src/components/ternary";
import Loadable from "src/routes/Loadable";
import { isBinary, isNotBinary } from "src/utils/isBinary";

const BrandSettings = Loadable(
  lazy(() => import("src/pages/admin/settings/brand"))
);
const BusinessSettings = Loadable(
  lazy(() => import("src/pages/admin/settings/business/index"))
);
const NetworkSettings = Loadable(
  lazy(() => import("src/pages/admin/settings/network/index"))
);

const Withdrawal = Loadable(
  lazy(() => import("src/pages/admin/settings/withdrawal/index"))
);

const Referral = {
  binary: Loadable(
    lazy(() => import("src/pages/admin/settings/network/@pages/referral/index"))
  ),
  nonBinary: Loadable(
    lazy(() => import("src/pages/admin/settings/network/@pages/settings/index"))
  ),
};

const Bonus = Loadable(
  lazy(() => import("src/pages/admin/settings/network/@pages/first/index"))
);

const Level = Loadable(
  lazy(() => import("src/pages/admin/settings/network/@pages/level/index"))
);
const Bronze = Loadable(
  lazy(() => import("src/pages/admin/settings/network/@pages/binary/index"))
);
const Binary = Loadable(
  lazy(() => import("src/pages/admin/settings/network/@pages/binary/index"))
);
const Rank = Loadable(
  lazy(() =>
    import("src/pages/admin/settings/network/@pages/rank-settings/index")
  )
);
const Packages = Loadable(
  lazy(() => import("src/pages/admin/settings/network/@pages/package/index"))
);

const Roi = Loadable(
  lazy(() => import("src/pages/admin/settings/network/@pages/roi/index"))
);

const HoldingDays = Loadable(
  lazy(() =>
    import("src/pages/admin/settings/network/@pages/holding-days/index")
  )
);
const Expiry = Loadable(
  lazy(() => import("src/pages/admin/settings/network/@pages/expiry/index"))
);
const Affiliate = Loadable(
  lazy(() => import("src/pages/admin/settings/network/@pages/affiliate/index"))
);
const NewRank = Loadable(
  lazy(() =>
    import("src/pages/admin/settings/network/@pages/Newrank-settings/index")
  )
);
const DollarPoint = Loadable(
  lazy(() =>
    import("src/pages/admin/settings/network/@pages/dollarPoint/index")
  )
);
const ServiceAndPrivacy = Loadable(
  lazy(() => import("src/pages/admin/settings/service-and-privacy/index"))
);

const settings = [
  {
    path: "settings",
    children: [
      { element: <Navigate to="brand" />, index: true },
      { path: "brand", element: <BrandSettings /> },
      { path: "service-and-privacy", element: <ServiceAndPrivacy /> },
      {
        path: "business",
        element: (
          <BinaryCheck>
            <BusinessSettings />
          </BinaryCheck>
        ),
      },
      {
        path: "network",
        element: <NetworkSettings />,
        children: [
          {
            index: true,
            element: <Navigate to={isNotBinary() ? "referral" : "rank"} />,
          },
          {
            path: "referral",
            element: (
              <Ternary
                when={isBinary()}
                then={<Referral.binary />}
                otherwise={<Referral.nonBinary />}
              />
            ),
          },

          {
            path: "bonus",
            element: <Bonus />,
          },
          {
            path: "level",
            element: <Level />,
          },
          {
            path: "package",
            element: <Packages />,
          },
          {
            path: "roi",
            element: <Roi />,
          },
          {
            path: "holding_days",
            element: <HoldingDays />,
          },
          {
            path: "expiry",
            element: <Expiry />,
          },
          {
            path: "affiliate_fee_settings",
            element: <Affiliate />,
          },
          {
            path: "dollar_point",
            element: <DollarPoint />,
          },

          {
            path: "binary",
            element: (
              <BinaryCheck>
                <Binary />
              </BinaryCheck>
            ),
          },
          {
            path: "rank",
            element: (
              <BinaryCheck>
                <NewRank />
              </BinaryCheck>
            ),
          },
          {
            path: "bronze",
            element: (
              <BinaryCheck>
                <Bronze />
              </BinaryCheck>
            ),
          },
        ],
      },
      { path: "withdrawal", element: <Withdrawal /> },
    ],
  },
];

export default settings;
